import React from "react";

type Props = {
	className?: string;
};
const SendIcon = ({ className = "" }: Props) => {
	return (
		<span style={{ width: 18, height: 18, position: "relative", top: 4 }}>
			<svg
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M3.79231 7.73922L1.9457 4.03925C0.883732 1.92208 0.356129 0.853343 0.843147 0.366326C1.33016 -0.120691 2.39213 0.413675 4.51607 1.46888L15.4672 6.95459C16.9621 7.7054 17.7061 8.07067 17.7061 8.66591C17.7061 9.26115 16.9621 9.62642 15.4672 10.3772L4.5093 15.8562C2.39213 16.9181 1.3234 17.4457 0.836382 16.9587C0.349365 16.4717 0.88373 15.4097 1.93894 13.2858L3.75849 9.65347L9.69739 9.65347C10.225 9.65347 10.6511 9.22733 10.6511 8.69973C10.6511 8.17213 10.225 7.74599 9.69739 7.74599H3.78554L3.79231 7.73922Z"
					fill="#D72229"
				/>
			</svg>
		</span>
	);
};

export default SendIcon;
